/**
 * Vishram — prescription routing gate
 *
 * 1. This is a ROUTING step, not verification. Checkout cannot be customised
 *    below Shopify Plus, so this gate lives in the cart, on the "check out"
 *    click, before checkout is reached.
 *
 * 2. Do NOT build the prescription list with a Liquid tag filter, e.g.
 *    `collections.all.products | where: 'tags', 'rx-required'`. That
 *    compares the tags array against a string and silently matches
 *    nothing. The product ID list below is rendered server-side from the
 *    manual collection with the handle `requires-prescription`.
 *
 * 3. This gate must FAIL OPEN. If /cart.js errors, or fetch is missing,
 *    leave checkout untouched.
 */
(function () {
  'use strict';

  if (window.__vishramCartGateInit) {
    return;
  }
  window.__vishramCartGateInit = true;

  try {
    var idsEl = document.getElementById('vishram-rx-products');
    var configEl = document.getElementById('vishram-config');
    if (!idsEl || !configEl) {
      return;
    }

    var rxProductIds = [];
    try {
      var parsedIds = JSON.parse(idsEl.textContent);
      if (Object.prototype.toString.call(parsedIds) === '[object Array]') {
        rxProductIds = parsedIds;
      }
    } catch (e) {
      return;
    }

    if (rxProductIds.length === 0) {
      return;
    }

    var config = {};
    try {
      config = JSON.parse(configEl.textContent) || {};
    } catch (e) {
      config = {};
    }

    var cartUrl = (config.routes && config.routes.cartUrl) || '/cart';

    if (typeof window.fetch !== 'function') {
      return;
    }

    var checkoutButtons = document.querySelectorAll(
      '[name="checkout"], [data-vishram-checkout-button]'
    );
    var buttons = Array.prototype.slice.call(checkoutButtons);
    if (buttons.length === 0) {
      return;
    }

    var notice = document.getElementById('vishram-rx-notice');

    function containsRxItem(cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var pid = String(items[i].product_id);
        for (var j = 0; j < rxProductIds.length; j++) {
          if (String(rxProductIds[j]) === pid) {
            return true;
          }
        }
      }
      return false;
    }

    function alreadyAcknowledged() {
      try {
        return window.sessionStorage.getItem('vishram_rx_acknowledged') === '1';
      } catch (e) {
        return false;
      }
    }

    function handleClick(e) {
      if (alreadyAcknowledged()) {
        return;
      }

      var button = e.currentTarget;

      fetch(cartUrl + '.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) {
            throw new Error('cart.js not ok');
          }
          return res.json();
        })
        .then(function (cart) {
          if (containsRxItem(cart) && notice) {
            e.preventDefault();
            notice.hidden = false;
            notice.setAttribute('aria-hidden', 'false');
            if (button && button.setAttribute) {
              button.setAttribute('aria-expanded', 'true');
            }
          }
        })
        .catch(function () {
        });
    }

    for (var k = 0; k < buttons.length; k++) {
      buttons[k].addEventListener('click', handleClick);
    }

    var ackBtn = notice && notice.querySelector('[data-rx-acknowledge]');
    if (ackBtn) {
      ackBtn.addEventListener('click', function () {
        try {
          window.sessionStorage.setItem('vishram_rx_acknowledged', '1');
        } catch (e) {
        }
        notice.hidden = true;
        notice.setAttribute('aria-hidden', 'true');
      });
    }
  } catch (err) {
    if (window.console && window.console.error) {
      window.console.error('vishram cart-gate error', err);
    }
  }
})();
